import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';

const buttonVariants = cva(
  "justify-center items-center inline-flex rounded-[28px] transition-colors", 
  {
    variants: {
      variant: {
        primary: [
          "bg-[#111111] text-white",
          "hover:bg-[#666666]",
          "active:bg-black",
        ],
        danger: [
          "bg-[#ff2b00] text-white",
          "hover:bg-[#ff4f26]",
          "active:bg-[#d12200]",
        ],
        default: [
          "bg-white border border-[#dddddd] text-[#111111]",
          "hover:text-[#666666]",
          "active:border-black active:text-black",
        ],
      },
      size: {
        xl: "h-14 px-7 text-lg font-bold leading-[27px]",
        l: "h-12 px-6 text-base font-normal leading-normal",
        m: "h-9 px-[18px] text-sm font-normal leading-[21px]",
        s: "h-7 px-3.5 text-xs font-normal leading-[18px]",
      },
      disabled: {
        true: "bg-[#eeeeee] text-[#aaaaaa] cursor-not-allowed border-none hover:bg-[#eeeeee] hover:text-[#aaaaaa] active:bg-[#eeeeee] active:text-[#aaaaaa] active:border-none",
      }
    },
    defaultVariants: {
      variant: "default",
      size: "l",
      disabled: false,
    },
  }
);

const Button = forwardRef(({ 
  className,
  childContainerClassName,
  variant,
  size,
  disabled,
  children,
  as: Component = 'button',
  ...props 
}, ref) => {
  return (
    <Component
      ref={ref}
      className={buttonVariants({ variant, size, disabled, className })}
      disabled={Component === 'button' ? disabled : undefined}
      {...props}
    >
      <div className={`justify-center items-center gap-2 flex ${childContainerClassName}`}>
        {children}
      </div>
    </Component>
  );
});

Button.displayName = "Button";

export default Button; 
